import {observer} from "mobx-react-lite";
import {useContext} from "react";
import styled from "styled-components";
import {MladiVoznikStoreContext} from "../mladi_voznik/form_mladi_voznik";
import {MladiVoznikStore} from "../../stores/mladi_voznik_store";
import {ReservationLevel} from "../../stores/reservation_store";

const LEVELS: { [k in ReservationLevel]: { background: string, color: string } } = {
    ok: {background: 'transparent', color: '#002D62'},
    warn: {background: '#FED505AA', color: '#002D62'},
    critical: {background: '#CC0000AA', color: '#FFFFFF'},
};

/**
 * Enotna višina vrstice. Vsak element sam centrira svojo pisavo v njej, zato sta
 * besedili poravnani kljub različnim velikostim: `align-items: center` poravna
 * okvirje, ne pisave, okvir pisave pa ni simetričen okoli črk (ascent != descent),
 * zamik pa raste z velikostjo pisave. Pri -apple-system se pri 20px zamenja tudi
 * rez (SF Pro Text -> Display), ki ima druge navpične metrike.
 */
const ROW_HEIGHT = 30;
const ROW_HEIGHT_MOBILE = 24;

const TimerContainer = styled.div<{ $level: ReservationLevel }>`
    position: absolute;
    top: 14px;
    right: 0;
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: flex-end;
    gap: 10px;
    padding: 8px 20px;
    border-radius: 20px 0 0 20px;
    box-sizing: border-box;
    color: ${({$level}) => LEVELS[$level].color};
    background-color: ${({$level}) => LEVELS[$level].background};
    transition: background-color 300ms ease, color 300ms ease;

    @media (max-width: 500px) {
        top: 8px;
        gap: 8px;
        padding: 6px 14px;
    }
`;

const TimerLabel = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: .08em;
    /* letter-spacing doda prostor tudi za zadnjim znakom - brez popravka je
       besedilo videti zamaknjeno v levo */
    margin-right: -.08em;
    white-space: nowrap;
`;

const TimerValue = styled.span`
    display: inline-flex;
    align-items: baseline;
    font-size: 15px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
`;

/**
 * Odštevalnik nad sliko v glavi obrazca. Teče do roka, ki ga je poslal strežnik;
 * o poteku odloča strežnik (glej ReservationStore).
 *
 * Podaljšanje je namenoma samo v opozorilu in oknu (glej reservation_dialogs) -
 * tu bi se gumb pojavil šele proti koncu in premikal širino okvirja, hkrati pa
 * uporabnika vabil h klikanju, čeprav je podaljšanj omejeno število.
 */
export const ReservationTimer = observer(() => {
    const store = useContext(MladiVoznikStoreContext) as MladiVoznikStore;
    const reservation = store.reservation;
    if (!reservation.active) return null;

    return <TimerContainer $level={reservation.level}
                           role={'timer'}
                           aria-label={`Čas za prijavo poteče čez ${reservation.remainingLabel}`}>
        <TimerLabel>ČAS ZA PRIJAVO:</TimerLabel>
        <TimerValue>{reservation.remainingLabel}</TimerValue>
    </TimerContainer>;
});
